import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {css} from "@emotion/react";
import styled from "@emotion/styled";
import * as Yup from "yup";

import {Button as DSButton} from "@pg-design/button-module";
import {calculateRemSize, flex, m, mt, w100} from "@pg-design/helpers-css";
import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";
import {FormFieldType} from "@pg-mono/form";
import {handleFormikPost, IFormikSubmitFn} from "@pg-mono/formik-utils";
import {FormikForm} from "@pg-mono/formik-utils";
import {rpAppPath} from "@pg-mono/rp-routes";

import {IRPStore} from "../../app/rp_reducer";
import {alertFormErrorMessage, alertFormSuccessMessage} from "../../application/utils/alert_text";
import {toJsonValues} from "../../form/translate/to_json_values";
import {validationMessages} from "../../form/utils/validation_messages";
import {addSuccessNotification} from "../../notifications/utils/add_success_notification";
import {addWarningNotification} from "../../notifications/utils/add_warning_notification";
import {postContractorApplication} from "../api/post_contractor_application";

const defaultInitialValues = {
    email: "",
    name: "",
    phone: {code: 48, number: ""},
    company: "",
    text: "Jestem zainteresowany/a współpracą. Proszę o kontakt."
};

export type ContractorApplicationFormValuesType = typeof defaultInitialValues;

const validationSchema = Yup.object({
    email: Yup.string().required(validationMessages.required).email(validationMessages.email),
    name: Yup.string().required(validationMessages.required),
    phone: Yup.object({
        code: Yup.number().required(validationMessages.required),
        number: Yup.string().required(validationMessages.required)
    }),
    company: Yup.string().required(validationMessages.required)
});

export const ContractorApplication = () => {
    const dispatch = useDispatch();

    const countryCodes = useSelector((state: IRPStore) => state.variables.data?.country_codes) ?? [];

    const onSubmit: IFormikSubmitFn<ContractorApplicationFormValuesType> = (values, formikHelpers) => {
        const data = {
            ...values,
            phone: toJsonValues({phone: FormFieldType.PhoneField}, values)?.phone
        };

        handleFormikPost(postContractorApplication(data), formikHelpers, {
            onNonFieldError: () => {
                dispatch(addWarningNotification(alertFormErrorMessage));
            },
            onSuccess: () => {
                dispatch(addSuccessNotification(alertFormSuccessMessage));

                formikHelpers.resetForm();
            }
        });
    };

    return (
        <div css={[mt(3), w100]} id="zarejestruj-firme">
            <Text as="p" color="#fff" variant="headline_4" strong>
                Skontaktuj się z nami
            </Text>

            <FormikForm
                css={form}
                initialValues={defaultInitialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
                enableReinitialize
                onChange={() => null}
            >
                <FormikForm.Input name="name" placeholder="Imię i nazwisko" />
                <FormikForm.Input name="company" placeholder="Firma" />
                <FormikForm.Input name="email" placeholder="Email" />

                <FormikForm.PhoneField name="phone" codes={countryCodes} placeholder="Numer telefonu" className="bt" />

                <Text align="center" color="#fff" variant="info_txt_2">
                    Administratorem Twoich danych osobowych jest Property Group sp. z o.o.,{" "}
                    <Link color="#fff" href={rpAppPath.rodoTerms.base} size="inherit" target="_blank">
                        zobacz, po co nam Twoje dane i jakie masz prawa
                    </Link>
                </Text>

                <Button css={m(0, "auto")} variant="filled_primary">
                    Wyślij
                </Button>

                <Text align="center" color="#fff" variant="info_txt_2">
                    Akceptuję{" "}
                    <Link color="#fff" href={rpAppPath.partnersTerms.base} size="inherit" target="_blank">
                        regulamin
                    </Link>{" "}
                    portalu
                </Text>
            </FormikForm>
        </div>
    );
};

const form = css`
    ${mt(3)};
    ${flex()};
    flex-direction: column;
    row-gap: ${calculateRemSize(2)};
`;

const Button = styled(DSButton)`
    min-width: 22rem;
`;
import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {css} from "@emotion/react";
import styled from "@emotion/styled";
import * as Yup from "yup";

import {Button as DSButton} from "@pg-design/button-module";
import {calculateRemSize, flex, m, mt, w100} from "@pg-design/helpers-css";
import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";
import {FormFieldType} from "@pg-mono/form";
import {handleFormikPost, IFormikSubmitFn} from "@pg-mono/formik-utils";
import {FormikForm} from "@pg-mono/formik-utils";
import {rpAppPath} from "@pg-mono/rp-routes";

import {IRPStore} from "../../app/rp_reducer";
import {alertFormErrorMessage, alertFormSuccessMessage} from "../../application/utils/alert_text";
import {toJsonValues} from "../../form/translate/to_json_values";
import {validationMessages} from "../../form/utils/validation_messages";
import {addSuccessNotification} from "../../notifications/utils/add_success_notification";
import {addWarningNotification} from "../../notifications/utils/add_warning_notification";
import {postContractorApplication} from "../api/post_contractor_application";

const defaultInitialValues = {
    email: "",
    name: "",
    phone: {code: 48, number: ""},
    company: "",
    text: "Jestem zainteresowany/a współpracą. Proszę o kontakt."
};

export type ContractorApplicationFormValuesType = typeof defaultInitialValues;

const validationSchema = Yup.object({
    email: Yup.string().required(validationMessages.required).email(validationMessages.email),
    name: Yup.string().required(validationMessages.required),
    phone: Yup.object({
        code: Yup.number().required(validationMessages.required),
        number: Yup.string().required(validationMessages.required)
    }),
    company: Yup.string().required(validationMessages.required)
});

export const ContractorApplication = () => {
    const dispatch = useDispatch();

    const countryCodes = useSelector((state: IRPStore) => state.variables.data?.country_codes) ?? [];

    const onSubmit: IFormikSubmitFn<ContractorApplicationFormValuesType> = (values, formikHelpers) => {
        const data = {
            ...values,
            phone: toJsonValues({phone: FormFieldType.PhoneField}, values)?.phone
        };

        handleFormikPost(postContractorApplication(data), formikHelpers, {
            onNonFieldError: () => {
                dispatch(addWarningNotification(alertFormErrorMessage));
            },
            onSuccess: () => {
                dispatch(addSuccessNotification(alertFormSuccessMessage));

                formikHelpers.resetForm();
            }
        });
    };

    return (
        <div css={[mt(3), w100]} id="zarejestruj-firme">
            <Text as="p" color="#fff" variant="headline_4" strong>
                Skontaktuj się z nami
            </Text>

            <FormikForm
                css={form}
                initialValues={defaultInitialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
                enableReinitialize
                onChange={() => null}
            >
                <FormikForm.Input name="name" placeholder="Imię i nazwisko" />
                <FormikForm.Input name="company" placeholder="Firma" />
                <FormikForm.Input name="email" placeholder="Email" />

                <FormikForm.PhoneField name="phone" codes={countryCodes} placeholder="Numer telefonu" className="bt" />

                <Text align="center" color="#fff" variant="info_txt_2">
                    Administratorem Twoich danych osobowych jest Property Group sp. z o.o.,{" "}
                    <Link color="#fff" href={rpAppPath.rodoTerms.base} size="inherit" target="_blank">
                        zobacz, po co nam Twoje dane i jakie masz prawa
                    </Link>
                </Text>

                <Button css={m(0, "auto")} variant="filled_primary">
                    Wyślij
                </Button>

                <Text align="center" color="#fff" variant="info_txt_2">
                    Akceptuję{" "}
                    <Link color="#fff" href={rpAppPath.partnersTerms.base} size="inherit" target="_blank">
                        regulamin
                    </Link>{" "}
                    portalu
                </Text>
            </FormikForm>
        </div>
    );
};

const form = css`
    ${mt(3)};
    ${flex()};
    flex-direction: column;
    row-gap: ${calculateRemSize(2)};
`;

const Button = styled(DSButton)`
    min-width: 22rem;
`;
